/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Activity_metrics = {|
  +openJobOffers: ?number;
  +openJobRequestsWithNoOffers: ?number;
  +openJobRequests: ?number;
  +startedJobs: ?number;
  +pendingTutors: ?number;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Activity_metrics",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "openJobOffers",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "openJobRequestsWithNoOffers",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "openJobRequests",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "startedJobs",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "pendingTutors",
      "storageKey": null
    }
  ],
  "type": "Metrics"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/home/activity/__generated__/Activity_metrics.graphql.js